"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactUuid = require("react-uuid");

var _reactUuid2 = _interopRequireDefault(_reactUuid);

var _reactBootstrap = require("react-bootstrap");

var _card = require("./card");

var _card2 = _interopRequireDefault(_card);

var _styled = require("./styled.gallery");

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _dummyProducts = require("./dummyProducts");

var _dummyProducts2 = _interopRequireDefault(_dummyProducts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Gallery = function Gallery(props) {
  var newProps = _extends({}, _defaultProps2.default.props, props.galleryCSS);
  var _newProps$style = newProps.style,
      style = _newProps$style === undefined ? {} : _newProps$style;


  var styledRowProps = {
    background: style.background
  };

  var products = props.products,
      handleCurrentPageValue = props.handleCurrentPageValue,
      parentURL = props.parentURL,
      _props$currentPage = props.currentPage,
      currentPage = _props$currentPage === undefined ? 1 : _props$currentPage,
      _props$productCount = props.productCount,
      productCount = _props$productCount === undefined ? 0 : _props$productCount,
      cardStyle = props.cardStyle,
      role = props.role,
      _props$store = props.store,
      store = _props$store === undefined ? {} : _props$store;


  var productPerPage = 20;
  var totalPages = 1;

  if (productCount) {
    totalPages = Math.ceil(productCount / productPerPage);
  }

  var getRowWiseData = function getRowWiseData(list) {
    var updatedList = [].concat(_toConsumableArray(list));
    var resultList = [];

    while (updatedList.length) {
      resultList.push(updatedList.splice(0, 4));
    }

    return resultList;
  };

  var getMappedData = function getMappedData(list) {
    var mappedList = [];

    var url = parentURL ? parentURL + "/products" : "";

    list.forEach(function (arr) {
      var _ref = store || {},
          _ref$moneyFormat = _ref.moneyFormat,
          moneyFormat = _ref$moneyFormat === undefined ? "$" : _ref$moneyFormat;

      var row = arr.map(function (item) {
        var _id = item._id,
            title = item.title,
            _item$description = item.description,
            description = _item$description === undefined ? "" : _item$description,
            handle = item.handle,
            price = item.price,
            primaryImageUrl = item.primaryImageUrl,
            shopifyProductId = item.shopifyProductId; // variants

        var productURL = "";

        if (url && handle && shopifyProductId) {
          productURL = url + "/" + handle;
        }

        return _react2.default.createElement(
          _reactBootstrap.Col,
          {
            xs: 6,
            lg: 3,
            key: "productParentDiv" + _id,
            className: "mb-4 position-relative"
          },
          _react2.default.createElement(_card2.default, {
            text: {
              alt: title,
              description: description,
              price: moneyFormat + " " + (price || 0.0),
              productURL: productURL,
              srcURL: primaryImageUrl && primaryImageUrl.trim(),
              title: title
            },
            style: _extends({}, cardStyle)
          })
        );
      });
      mappedList.push(row);
    });

    return mappedList;
  };

  var productLists = function productLists() {
    if (products && products.length) {
      var formattedData = getRowWiseData(products);
      var mappedData = getMappedData(formattedData);

      return mappedData.map(function (item) {
        return _react2.default.createElement(
          _styled.StyledRow,
          _extends({}, styledRowProps, { className: "row", key: (0, _reactUuid2.default)() }),
          item
        );
      });
    } else if (role === "seller") {
      // role === "seller" is only for page builder seller side adding dummy products
      return _react2.default.createElement(
        _styled.StyledRow,
        _extends({}, styledRowProps, { className: "row", key: (0, _reactUuid2.default)() }),
        _react2.default.createElement(_dummyProducts2.default, null)
      );
    }
    return _react2.default.createElement(
      "div",
      { className: "text-center" },
      "No Products found"
    );
  };

  return _react2.default.createElement(
    _reactBootstrap.Container,
    { className: "px-lg-4" },
    productLists(),
    totalPages > 1 && _react2.default.createElement(
      "ul",
      { className: "pagination mb-0 justify-content-center" },
      currentPage !== 1 && _react2.default.createElement(
        _styled.PaginationItem,
        { className: "page-item" },
        _react2.default.createElement(
          "button",
          {
            type: "button",
            onClick: function onClick() {
              return handleCurrentPageValue("previous");
            }
          },
          _react2.default.createElement("i", { className: "fa fa-long-arrow-left", "aria-hidden": "true" })
        )
      ),
      currentPage !== totalPages && _react2.default.createElement(
        _styled.PaginationItem,
        { className: "page-item" },
        _react2.default.createElement(
          "button",
          {
            type: "button",
            onClick: function onClick() {
              return handleCurrentPageValue("next");
            }
          },
          _react2.default.createElement("i", { className: "fa fa-long-arrow-right", "aria-hidden": "true" })
        )
      )
    ) || ""
  );
};

exports.default = Gallery;